<template>
  <v-container fluid grid-list-xl style="top: -110px; left: 0px;" class="card-animate-2">
    <v-layout row wrap>
     <v-flex sm12 xs12 md12 lg12>
      <div id="app">
        <div class="container-fluid">
          <div class="editor item active">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="box box-pm">
                                            <div class="box-header"><b>HTML</b> <div class="btn btn-info" data-toggle="modal" data-target="#choose-bg">Background</div></div>
                                            <div class="box-body">
                                                <div id="promo-html-editor" data-target="#promo-html"></div>
                                                <textarea class="hideme" id="promo-html" name="promo-html" data-type=".html"><div class="deal-content">
    <h1 class="title">Deals of the Day</h1>
    <h4 class="details">Toronto (YYZ) to Paris (CDG)</h4>
    <div class="price">C$ 15% OFF</div>
</div></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="box box-pm">
                                            <div class="box-header"><b>CSS</b></div>
                                            <div class="box-body">
                                                <div id="promo-css-editor" data-target="#promo-css"></div>
                                                <textarea class="hideme" id="promo-css" name="promo-css" data-type="style">
.preview {
    display:flex !important;
    flex-direction:column;
    justify-content:center;
}

.deal-content {
    text-align:center;
    background-color:rgba(12, 166, 220, 0.9);
    color:#fff;
    padding:15px 0px;
}

.deal-content .title{
    font-weight:bold;
    text-transform:uppercase;
    margin:0;
    line-height:1;
}
.deal-content .details {
    margin:30px 0px;
    font-weight:bold;
    line-height:1;
}

.deal-content .price {
    height:44px;
    line-height:44px;
    display:inline-block;
    padding:0 20px;
    background-color:#fff;
    color:rgb(12, 166, 220);
    font-size:18px;
    font-weight:bold;
    border-radius:30px;
}</textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="box box-pm">
                                            <div class="box-header"><b>JavaScript</b></div>
                                            <div class="box-body">
                                                <div id="promo-js-editor" data-target="#promo-js"></div>
                                                <textarea class="hideme" id="promo-js" name="promo-js" data-type="script"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
<div class="preview-wrapper">
                                <div class="box box-pm">
                                    <div class="box-header">
                                        <div class="preview-options-wrapper">
                                            <div class="preview-options" data-css="width">
                                                <label>Width</label>
                                                <input type="number" class="form-control" id="preview-width">
                                            </div>
                                            <div class="preview-options" data-css="height">
                                                <label>Height</label>
                                                <input type="number" class="form-control" id="preview-height">
                                            </div>
                                            <div class="preview-options align">
                                                <label>Align</label>
                                                <span class="preview-icon" data-preview-align="pull-left">
                                                    <i class="fa fa-align-left"></i>
                                                </span>
                                                <span class="preview-icon" data-preview-align="center">
                                                    <i class="fa fa-align-center"></i>
                                                </span>
                                                <span class="preview-icon" data-preview-align="pull-right">
                                                    <i class="fa fa-align-right"></i>
                                                </span>
                                            </div>
                                          <div class="preview-options device">
                                                    <label>Devices</label>
                                                    <span class="preview-icon" data-preview-device="mobile">
                                                        <i class="fa fa-mobile-phone"></i>
                                                    </span>
                                                    <span class="preview-icon"  data-preview-device="tab">
                                                        <i class="fa fa-tablet"></i>
                                                    </span>
                                                    <span class="preview-icon" data-preview-device="laptop">
                                                        <i class="fa fa-laptop"></i>
                                                    </span>
                                                    <span class="preview-icon active" data-preview-device="">
                                                        <i class="fa fa-desktop"></i>
                                                    </span>
                                                </div>
                                        </div>
                                    </div>
                                    <div class="box-body">
                                        <div class="preview-option-wrapper">
                                            <div class="preview">
                                                <!-- <style></style> -->
                                                <div class="html"></div>
                                    
                                                <!-- <script></script> -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
  
  
  <input type="text" class="hideme" name="promo-bg" id="promo-bg">
                            <!-- Modal -->
                            <div class="modal style-1" id="choose-bg" role="dialog">
                                <div class="modal-dialog modal-lg">
                            
                                    <!-- Modal content-->
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                                            <h4 class="modal-title">Choose Background Image</h4>
                                        </div>
                                        <div class="modal-body">
                                            <div class="dnd-file-uploader">
                                                <input class="hideme" type="file" accept=".jpg,.png" name="promo-bg" id="promo-bg">
                                                <div class="dnd-file-handler">
                                                    DROP IMAGE OR CLICK ME
                                                </div>
                                            </div>
                                            <div class="row image-images-container">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

</div>
</div>

    </v-flex>
  </v-layout>
</v-container>
</template>
<script src="../components/editor/script.js"></script>

<script>
export default {
  name: 'editor',
  components: {
  },
  data() {
    return {
      sortBy: 'fat',
      sortDesc: false,
      scrollInvoked: 0,
      date: new Date(),
      selectedAccountDetails: {},
      selectedContactDetails: {},
      selectedProductInfo: {},
      modal_date_picker: false,
      form_valid: true,
      form_valid_msg: '',
    };
  },
 
  mounted() {

  },
   
  watch: {
    searchAccountName(val) {
      if (!val) return;
      this.isLoading = true;
      fetch(`${process.env.VUE_APP_NODE_SERVER}account-form/search`, {
        method: 'POST',
        body: JSON.stringify({ searchText: val }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.clone().json())
        .then((res) => {
          this.account_list = res.result;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    searchContactName(val) {
      // Items have already been loaded
      // if(!val) return
      // if (this.contact_list.length > 0) return;
      this.isLoading = true;
      fetch(`${process.env.VUE_APP_NODE_SERVER}contact-form/search`, {
        method: 'POST',
        body: JSON.stringify({ searchText: val }), // string or object
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      })
        .then((res) => res.clone().json())
        .then((res) => {
          this.contact_list = res.result;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    selectedAccountDetails(val) {
      if (!val) return;
      this.formFields.email = val.email ? val.email : '';
      this.formFields.accountName = val.accountName ? val.accountName : '';
      this.formFields.street = val.street ? val.street : '';
      this.formFields.city = val.city ? val.city : '';
      this.formFields.state = val.state ? val.state : '';
      this.formFields.zipcode = val.zipcode ? val.zipcode : '';
      this.formFields.accountType = val.accountType ? val.accountType : '';
      this.contact_list.push(this.formFields);
      this.account_list.push(this.formFields);
    },
  },
  methods: {
    toggleOrder() {
      this.sortDesc = !this.sortDesc;
    },
    nextSort() {
      let index = this.headers.findIndex((h) => h.value === this.sortBy);
      index = (index + 1) % this.headers.length;
      this.sortBy = this.headers[index].value;
    },
    initialize() {
      this.InvoicesList = [];
    },
    getDashboard: async function() {
      const rawResponse = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}analytics/all`
      );
      const content = await rawResponse.json();
      this.dashboard = content.response;
      console.log(content);
    },
    add() {
      this.inputs.push({
        Make: '',
        Model: '',
        price: '',
        quantity: '',
        amount: '',
        IMEI: '',
        Memory: '',
        Carrier: '',
        Color: '',
      });
      console.log(this.inputs);
      this.productsList = [];
    },
    remove(index) {
      this.inputs.splice(index, 1);
      this.productsList = [];
    },
    onScroll() {
      this.scrollInvoked++;
    },
    selectProduct(product, i) {
      console.log(product);
      this.inputs[i].Make = product.Make;
      this.inputs[i].Model = product.Model;
      this.inputs[i].IMEI = product.IMEI;
      this.inputs[i].Memory = product.Memory;
      this.inputs[i].Carrier = product.Carrier;
      this.inputs[i].Color = product.Color;
      this.inputs[i].price = product.price;
      this.inputs[i].quantity = product.quantity;
      this.productsList = [];
      this.selectedProductInfo = product;
      this.type = '';
    },
    searchProducts(event, index, type) {
      if (!event.target.value) return;
      this.productLoader = true;
      this.optionIndex = index;
      this.type = type;
      if (type == 'product') {
        setTimeout(() => {
          fetch(`${process.env.VUE_APP_NODE_SERVER}product-master/search`, {
            method: 'POST',
            body: JSON.stringify({ searchText: event.target.value }), // string or object
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
          })
            .then((res) => res.clone().json())
            .then((res) => {
              this.productsList = res.result;
              this.productLoader = false;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => (this.productLoader = false));
        }, 1000);
      } else if (type == 'imei') {
        setTimeout(() => {
          fetch(
            `${process.env.VUE_APP_NODE_SERVER}product-master/iemi-search`,
            {
              method: 'POST',
              body: JSON.stringify({ searchText: event.target.value }), // string or object
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
            }
          )
            .then((res) => res.clone().json())
            .then((res) => {
              this.productsList = res.result;
              this.productLoader = false;
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => (this.productLoader = false));
        }, 1000);
      }
    },
    searchInvoice: async function() {
      console.log(this.search);
      if (!this.search) this.getInvoicesList();
      this.isLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/search`,
        {
          method: 'POST',
          body: JSON.stringify({ searchText: this.search }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json();
      this.isLoading = false;
      console.log(json);
      this.invoicesList = json.result;
    },
    getInvoicesList: async function() {
      this.tableLoader = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/all`
      );
      const json = await response.json();
      console.log(json);
      this.invoicesList = json.result;
      this.dashboard.accounts = this.invoicesList.reduce(
        (acc, o) => ((acc[o.accountName] = (acc[o.accountName] || 0) + 1), acc),
        {}
      );
      this.dashboard.accounts = Object.keys(this.dashboard.accounts).length;
      this.tableLoader = false;
    },
    updateProductStatus: async function() {
      this.selectedProductInfo.status = 'Sold';
      this.selectedProductInfo.SellingPrice = this.formFields.total;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}product-master/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.selectedProductInfo), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      console.log(response);
    },
    submitForm2: async function() {
      this.isLoading = true;
      setTimeout(() => {
        this.readOutLoud('Successfuly emailed generated Program');
        this.buttonLoader = true;
        this.showEmailConfirmation = true;
        this.resetForm();
      }, 2000);
    },


    submitForm: async function() {
      console.log(this.formFields);
      // console.log(this.inputs[0])
      this.formFields.accountName = this.selectedAccountDetails.accountName;
      this.formFields.contactName = this.selectedContactDetails.contactName;
      if (!this.inputs[0].Make) {
        this.$notify({
          group: 'foo',
          title: 'Important message',
          text: 'Please add products',
        });
        return;
      }
      console.log(this.selectedAccountDetails);
      console.log(this.selectedContactDetails);
      this.formFields.productsList = this.inputs;
      this.formFields.quantity = this.inputs.length;
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/create`,
        {
          method: 'POST',
          body: JSON.stringify({ ...this.formFields }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.updateProductStatus();
      setTimeout(() => {
        this.readOutLoud('Invoice Created');
        this.getInvoicesList();
        this.resetForm();
      }, 800);
    },
    deleteConfirmation: function(item) {
      this.itemToBeDeleted = item;
      this.showConfirmation = true;
    },
    deleteInvoice: async function() {
      this.loading3 = true;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/delete`,
        {
          method: 'POST',
          body: JSON.stringify({ id: this.itemToBeDeleted._id }), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      this.itemToBeDeleted = '';
      this.showConfirmation = false;
      this.loading3 = false;
      setTimeout(() => {
        this.readOutLoud('1 record deleted');
        this.getInvoicesList();
      }, 800);
    },
    editInvoice: function(data) {
      this.overlay = true;
      this.editForm = true;
      this.formFields = data;
      this.inputs = data.productsList;
      this.selectedAccountDetails = this.formFields;
      this.selectedContactDetails = this.formFields;
      console.log(this.formFields.accountName);
      console.log(this.formFields.contactName);
    },
    updateInvoice: async function() {
      this.loading3 = true;
      this.formFields.accountName = this.selectedAccountDetails.accountName;
      this.formFields.contactName = this.selectedContactDetails.contactName;
      const response = await fetch(
        `${process.env.VUE_APP_NODE_SERVER}invoice-form/update`,
        {
          method: 'POST',
          body: JSON.stringify(this.formFields), // string or object
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        }
      );
      const json = await response.json(); //extract JSON from the http response
      console.log(json[0]);
      setTimeout(() => {
        this.readOutLoud('1 record updated');
        this.getInvoicesList();
        this.resetForm();
      }, 800);
    },
    resetForm: function() {
      this.overlay = false;
      this.editForm = false;
      this.loading3 = false;
      this.inputs = [
        {
        Make: '',
        Model: '',
        price: '',
        quantity: '',
        amount: '',
        IMEI: '',
        Memory: '',
        Carrier: '',
        Color: '',
        },
      ];
      this.formFields = {
        invoiceSubject: '',
        invoiceStatus: '',
        invoiceOwner: '',
        accountName: '',
        company: '',
        contactName: '',
        accountSource: '',
        accountType: '',
        paymentType: '',
        email: '',
        street: '',
        state: '',
        city: '',
        zipcode: '',
        invoiceDate: new Date(
          Date.now() - new Date().getTimezoneOffset() * 60000
        )
          .toISOString()
          .substr(0, 10),
        subTotal: '',
        total: '',
        quantity: 0,
        discount: 0,
        imei: '',
        tax: 9.5,
        productsList: [],
      };
    },
    openForm: function() {
      this.overlay = true;
      this.items = [];
      this.selectedProductInfo = [];
    },
    startListining: function() {
      setTimeout(() => {
        Event.$emit('speakModeOn');
      }, 1250);
    },
    beforeDestroy() {
      Event.$off('speakModeOn');
      Event.$off('openForm');
      Event.$off('searchFromRecord');
      Event.$off('editFromRecord');
    },
    readOutLoud: function(msg) {
      const speech = new SpeechSynthesisUtterance();
      speech.text = msg;
      speech.lang = 'en-GB';
      window.speechSynthesis.speak(speech);
      this.speak = msg;
    },
    fillForm: function(msg) {
      switch (this.currentField) {
        case 0:
          //Owner Name
          var owner = this.ownerOptions.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (owner) {
            this.formFields.invoiceOwner = owner;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 1:
          this.formFields.invoiceDate = dateCommand(msg);
          this.currentField++;
          break;
        case 2:
          this.formFields.invoiceSubject = msg;
          this.currentField++;
          break;
        case 3:
          var accountType = this.accountType.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (accountType) {
            this.formFields.accountType = accountType;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 4:
          this.formFields.accountName = msg;
          this.currentField++;
          break;
        case 5:
          var paymentType = this.paymentType.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (paymentType) {
            this.formFields.paymentType = paymentType;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 6:
          this.formFields.contactName = msg;
          this.currentField++;
          break;
        case 7:
          var invoiceStatus = this.invoiceStatus.filter(
            (obj) => obj.toLowerCase() == msg.toLowerCase()
          )[0];
          if (invoiceStatus) {
            this.formFields.invoiceStatus = invoiceStatus;
            this.currentField++;
          } else {
            this.readOutLoud('Unable to find from list, please try again');
          }
          break;
        case 8:
          this.formFields.street = msg;
          this.currentField++;
          break;
        case 9:
          this.formFields.state = msg;
          this.currentField++;
          break;
        case 10:
          this.formFields.city = msg;
          this.currentField++;
          break;
        case 11:
          this.formFields.zipcode = msg;
          this.currentField++;
          break;
        case 12:
          this.input.IMEI = msg;
          this.currentField++;
          break;
      }
      this.navigateField();
    },
    navigateField: function() {
      console.log(this.currentField);
      switch (this.currentField) {
        case 0:
          this.readOutLoud('Invoice Owner?');
          break;
        case 1:
          this.readOutLoud('Invoice Date?');
          break;
        case 2:
          this.readOutLoud('Invoice Subject?');
          break;
        case 3:
          this.readOutLoud('Account Type?');
          break;
        case 4:
          this.readOutLoud('Account Name?');
          break;
        case 5:
          this.readOutLoud('Payment Type?');
          break;
        case 6:
          this.readOutLoud('Contact Name?');
          break;
        case 7:
          this.readOutLoud('Invoice Status?');
          break;
        case 8:
          this.readOutLoud('Street?');
          break;
        case 9:
          this.readOutLoud('State ?');
          break;
        case 10:
          this.readOutLoud('City ?');
          break;
        case 11:
          this.readOutLoud('Zip code ?');
          break;
        case 12:
          this.readOutLoud('IMEI?');
          break;
      }
      this.startListining();
    },
    async createInvoice() {
      const data = this.getSampleData();
      console.log(data);
      console.log(this.inputs);
      for (let i = 0; i < this.inputs.length; i++) {
        data.products.push({
          quantity: this.inputs[i].quantity,
          description: ' MODEL: ' + this.inputs[i].Make + 
          '   ' + this.inputs[i].Model + 
          '  IMEI:  ' + this.inputs[i].IMEI,
          'tax-rate': this.formFields.tax,
          price: this.inputs[i].amount,
        });
      
        // data.products[i].quantity = this.inputs[i].quantity
        // data.products[i].description = this.inputs[i].productName
        // data.products[i].Price = this.inputs[i].amount
      }
      const result = await easyinvoice.createInvoice(data);
      easyinvoice.download('myCellFundsInvoices.pdf', result.pdf);
      this.loading3 = false;
    },
    getSampleData() {
      this.loading3 = true;
      return {
        // "customize": {
        //     "template": "SGVsbG8gd29ybGQh" // Must be base64 encoded html. This example contains 'Hello World!' in base64
        // },
        images: {
          logo:
            'https://www.mycellfunds.com/wp-content/uploads/2020/03/Cell_Funds_Logo.png',
          // background:
          //   'https://public.easyinvoice.cloud/img/watermark-draft.jpg',
        },
        sender: {
          company: 'Cell Funds',
          address: '14429 Ventura Blvd. Ste. 108',
          city: 'Sherman Oaks',
          state: 'CA',
          zip: '91423',
          phonenumber: '1-818-989-3175',
          "website": "www.mycellfunds.com",
          "phone": "1-818-989-3175",
          // "custom2": "custom value 2",
          // "custom3": "custom value 3"
        },
        client: {
          company: this.formFields.accountName,
          address: this.formFields.street,
          city: this.formFields.city,
          state: this.formFields.state,
          zip: this.formFields.zipcode,
          // "custom1": "custom value 1",
          // "custom2": "custom value 2",
          // "custom3": "custom value 3"
        },
        information: {
          date: this.formFields.invoiceDate,
          number: this.formFields._id,
        },
        products: [],
        'bottom-notice': 'Tested for key functions R2 - Ready for Resale. 30-day warranty on device, starting from the date of purchase. Returns will not be accepted, if 30 day warranty has passed. <br><br> <hr> <h4>There is a 20% restocking fee on all retail returns, unless covered by Cell Funds Warranty.</h4> This warranty is broken by modifying the hardware or software of any product including physical damage. Phones which are damaged at the time of sale are non refundable. <br> <br> <hr> <h4> Clients that opp out of our AKKO Insurance Plan, still qualifies to receive 25% off any repairs from this transaction, after 30 day warranty expires. Inquire with your Cell Funds Tech Agent for more information.</h4> <br>  <h3>www.mycellfunds.com | 1(818)989-3175</h3>',
        settings: {
          currency: 'USD', // See documentation 'Locales and Currency' for more info. Leave empty for no currency.
          // "locale": "nl-NL", // Defaults to en-US, used for number formatting (see docs)
          // "taxNotation": "gst", // Defaults to vat
          // "margin-top": 25, // Default to 25
          // "margin-right": 25, // Default to 25
          // "margin-left": 25, // Default to 25
          // "margin-bottom": 25, // Default to 25
          // "format": "Letter" // Defaults to A4
        },
        // Used for translating the headers to your preferred language
        // Defaults to English. Below example is translated to Dutch
        translate: {
          invoice: 'Invoice',
        },
      };
    },
  },
};
</script>
<style>
.box {
  position: relative;
  background: rgba(23, 34, 49, 0.664);
  margin-bottom: 0px;
  width: 100%;
}
.box.collapsed-box .box-body,
.box.collapsed-box .box-footer {
  display: none;
}
.box .nav-stacked > li {
  margin: 0;
}
.box .nav-stacked > li:last-of-type {
  border-bottom: none;
}
.box.height-control .box-body {
  max-height: 300px;
  overflow: auto;
}
.box.box-solid {
  border-top: 0;
}
.box.box-solid > .box-header .btn.btn-default {
  background: transparent;
}
.box.box-solid > .box-header .btn:hover,
.box.box-solid > .box-header a:hover {
  background: rgba(0, 0, 0, 0.1);
}
.box.box-solid > .box-header > .box-tools .btn {
  border: 0;
  box-shadow: none;
}
.box.box-solid[class*='bg'] > .box-header {
  color: #fff;
}
.box .box-group > .box {
  margin-bottom: 5px;
}
.box .knob-label {
  text-align: center;
  color: #333;
  font-weight: 100;
  font-size: 12px;
  margin-bottom: 0.3em;
}
.box-pm {
  border: solid 0px #ccc;
  border-radius: 0;
}
.box-pm .box-header {
  color: rgb(255, 247, 247);
  display: block;
  padding: 10px;
  position: relative;
  padding-bottom: 0;
}
.box-pm .box-header .btn {
  border-radius: 0;
  position: absolute;
  height: 28px;
  padding: 0 10px !important;
  line-height: 25px;
  margin: auto;
  top: -1px;
  bottom: 0;
  right: 10px;
}
.box-pm .box-header:after {
  content: " ";
  display: block;
  padding-top: 9px;
  border-bottom: solid 1px #ccc;
}
.hideme {
  visibility: hidden;
  position: absolute;
  width: 0;
  height: 0;
}
#promo-css-editor,
#promo-html-editor,
#promo-js-editor {
  position: relative;
  height: 100px;
  width: 100%;
}
.box-body {
  padding: 0px;
  border-radius: 0 0 3px 3px;
}
.preview-options-wrapper {
  display: flex;
}
@media screen and (max-width: 768px) {
  .preview-options-wrapper {
    flex-direction: column;
  }
}
.preview-options-wrapper .preview-options {
  display: flex;
  align-items: center;
}
@media screen and (min-width: 768px) {
  .preview-options-wrapper .preview-options {
    flex-grow: 1;
    margin-right: 15px;
  }
  .preview-options-wrapper .preview-options:last-child {
    margin: 0;
    flex-grow: 0;
  }
}
@media screen and (max-width: 768px) {
  .preview-options-wrapper .preview-options {
    margin-bottom: 10px;
  }
  .preview-options-wrapper .preview-options:last-child {
    margin: 0;
  }
}
.preview-options-wrapper .preview-options label {
  margin-right: 10px;
  margin-bottom: 0;
}
.preview-options-wrapper .preview-options .preview-icon {
  width: 50px;
  height: 40px;
  line-height: 34px;
  text-align: center;
  border: solid 1px #ccc;
  margin: 0 5px;
  display: inline-block;
  cursor: pointer;
  transition: all 0.5s ease;
}
.preview-options-wrapper .preview-options .preview-icon.active {
  background-color: #00bfef67;
  color: #fff;
  border-color: #00c0ef;
}
.preview-options-wrapper .preview-options.device .preview-icon {
  font-size: 18px;
}
.preview-option-wrapper {
  width: 100%;
  position: relative;
}
.preview-option-wrapper:before,
.preview-option-wrapper:after {
  content: "";
  display: table;
}
.preview-option-wrapper:after {
  clear: both;
}
.preview-option-wrapper .preview {
  display: block;
  border: solid 0px #313039;
  border-radius: 15px;
}
.preview-option-wrapper .preview::after,
.preview-option-wrapper .preview::before {
  content: "";
  height: 0px;
  width: 0px;
  transform: all 0.5s;
}
.preview-option-wrapper .preview.center {
  margin: auto;
}
.preview-option-wrapper .preview.mobile {
  overflow: auto;
  border-width: 40px 15px 70px 15px;
  border-radius: 25px;
  transition: all 0.5s ease;
}
.preview-option-wrapper .preview.mobile::after,
.preview-option-wrapper .preview.mobile::before {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.514);
}
.preview-option-wrapper .preview.mobile::after {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  bottom: 15px;
}
.preview-option-wrapper .preview.mobile:before {
  width: 80px;
  height: 5px;
  top: 17.5px;
  border-radius: 10px;
}
.preview-option-wrapper .preview.tab {
  overflow: auto;
  border-width: 25px 15px 60px 15px;
  border-radius: 25px;
  transition: all 0.5s ease;
}
.preview-option-wrapper .preview.tab::before {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.514);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  bottom: 15px;
}
.preview-option-wrapper .preview.laptop {
  overflow: auto;
  width: auto !important;
  margin: 0 15px 40px 15px;
  border-width: 15px;
  border-radius: 10px;
  transition: all 0.5s ease;
}
.preview-option-wrapper .preview.laptop::after,
.preview-option-wrapper .preview.laptop::before {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  background-color: rgba(255, 255, 255, 0.514);
}
.preview-option-wrapper .preview.laptop::after {
  width: 100%;
  height: 40px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
  bottom: -5px;
  background-color: #555;
}
.preview-option-wrapper .preview.laptop:before {
  width: 10px;
  height: 10px;
  top: 2.5px;
  border-radius: 5px;
}
.preview-option-wrapper .preview::-webkit-scrollbar {
  width: 3px;
  background-color: #666;
}
.preview-option-wrapper .preview::-webkit-scrollbar-thumb {
  width: 3px;
  background-color: rgba(255, 255, 255, 0.514);
}
.form-control {
  border-radius: 0;
}
.modal-backdrop {
  background-color: rgba(0, 0, 0, 0.555);
}
.modal {
  visibility: hidden;
  background-color: transparent;
  display: block !important;
  transform: perspective(400px) scale(0.9) rotateX(-15deg) translateY(100%);
  opacity: 0;
  transition: all 0.5s ease;
}
.modal.in {
  transform: perspective(400px) scale(1) rotateX(0deg) translateY(0%);
  visibility: visible;
  opacity: 1;
}
.modal.style-1 .modal-header {
  background-color: #00c0ef;
  color: #fff;
}
.modal.style-1 .modal-header .close {
  opacity: 0.8;
  color: #Fff;
}
.modal.style-1 .footer {
  border-top: solid 1px #ccc;
  padding-top: 15px;
}
.modal-content {
  border-radius: 0;
}
.dnd-file-uploader .dnd-file-handler {
  width: 100%;
  border: solid 5px #ccc;
  height: 100px;
  font-size: 36px;
  text-align: center;
  line-height: 100px;
  color: #ccc;
  font-weight: bolder;
  cursor: pointer;
  margin-bottom: 15px;
}
.promo-images-wrapper {
  background-image: url('./../assets/AIBG.png');
  background-size: cover;
  background-position: center center;
  height: 250px;
  padding: 10px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.promo-images-wrapper .btn {
  border-radius: 0px;
  border: none;
}
.promo-images-wrapper .hover {
  text-align: center;
  padding: 10px 30px;
  background-color: rgba(255, 255, 255, 0.514);
  transform: perspective(800px) rotateY(90deg);
  transition: all 0.5s ease;
}
.promo-images-wrapper .hover .promo-bg-options {
  min-height: 100px;
}
.promo-images-wrapper:hover .hover {
  transform: perspective(800px) rotateY(0deg);
  transition: all 0.8s cubic-bezier(0.43, 2.11, 0.59, 0.79);
}
.url .live-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
</style>